/**
 * Card Component Design Tokens
 *
 * Maps to PrimeNG's p-card component.
 * These tokens control the visual styling of cards and their variants.
 *
 * Figma reference: https://www.figma.com/design/BO8nTOBfeA5X76DUhf4c5c/DS-Components---v2.1--Copy-?node-id=4667-33
 * Token reference: https://primeng.org/card#tokens
 *
 * PrimeNG official tokens:
 * - card.background
 * - card.borderRadius
 * - card.color
 * - card.shadow
 * - card.body.padding
 * - card.body.gap
 * - card.caption.gap
 * - card.title.fontSize
 * - card.title.fontWeight
 * - card.subtitle.color
 */
export const cardTokens = {
  card: {
    // -------------------------------------------------------------------------
    // PrimeNG official tokens
    // -------------------------------------------------------------------------
    root: {
      background: '{surface.0}',
      borderRadius: '{borderRadius.lg}',
      color: '{text.color}',
      shadow: '{shadow.base}'
    },
    body: {
      padding: '0',
      gap: '0'
    },
    caption: {
      gap: '0'
    },
    subtitle: {
      color: '{text.mutedColor}'
    }
  }
};

export type CardTokens = typeof cardTokens;
